import { filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '@env/environment';
import { Services, ShowService } from './services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  constructor(private http: HttpClient) { }

  getServices() {
      return this.http.get<Services>(`${env.domain}dashboard/services`);
  }
  addService(body:FormData){
    return this.http.post<Services>(`${env.domain}dashboard/services` , body);
  }
  updateService(body:FormData,ServiceId:number){
    return this.http.post<Services>(`${env.domain}dashboard/services/${ServiceId}?_method=PUT` , body);
  }
  deactivate(ServiceId:number) {
    return this.http.get<Services>(`${env.domain}dashboard/services/deactivate/${ServiceId}`);
  }
  activate(ServiceId:number) {
    return this.http.get<Services>(`${env.domain}dashboard/services/activate/${ServiceId}`);
  }
  delete(ServiceId:number) {
    return this.http.delete<Services>(`${env.domain}dashboard/services/${ServiceId}`);
  }
  showServices(ServiceId:number) {
    return this.http.get<ShowService>(`${env.domain}dashboard/services/${ServiceId}`);
  }
  getUserCompanies(): Observable<any> {
    return this.http.get(`${env.domain}Companies/GetUserCompanies`);
  }
  addTaskType(body:any){
    return this.http.post<Services>(`${env.domain}TaskType/AddTaskType` , body);
  }
  editTaskType(id:number,body:any){
    return this.http.put<Services>(`${env.domain}TaskType/Update/${id}` , body);
  }
  deleteTaskType(id:number){
    return this.http.delete<Services>(`${env.domain}TaskType/Delete/${id}` );
  }
  getEmployeeTasksSummary(body:any): Observable<any> {
      return this.http.post(`${env.domain}Tasks/EmployeeTasksSummary`,body);

  }
}
